import React, { useState } from 'react';

function ImageUploader({ onImageUrl, currentImage }) {
  const [uploading, setUploading] = useState(false);
  const [dragOver, setDragOver] = useState(false);

  const handleFileUpload = async (file) => {
    if (!file || !file.type.startsWith('image/')) {
      alert('Please select a valid image file');
      return;
    }

    // Check file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      alert('File size must be less than 5MB');
      return;
    }

    setUploading(true);
    
    try {
      // Convert file to base64 for preview
      const base64 = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(file);
      });
      
      // Store file data temporarily (don't upload to S3 yet)
      const tempImageData = {
        file: file,
        preview: base64,
        fileName: file.name,
        contentType: file.type
      };
      
      // Pass the temp data to parent component
      onImageUrl(tempImageData);
      alert('✅ Image ready for upload! Will upload when you publish the article.');
      
    } catch (error) {
      alert('❌ Error processing image: ' + error.message);
    } finally {
      setUploading(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files[0];
    handleFileUpload(file);
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    handleFileUpload(file);
  };

  return (
    <div className="image-uploader">
      <div 
        className={`upload-zone ${dragOver ? 'drag-over' : ''}`}
        onDrop={handleDrop}
        onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
        onDragLeave={() => setDragOver(false)}
      >
        {currentImage ? (
          <div className="current-image">
            <img 
              src={typeof currentImage === 'string' ? currentImage : currentImage.preview} 
              alt="Article" 
              style={{maxWidth: '200px', maxHeight: '150px'}} 
            />
            <button type="button" onClick={() => onImageUrl('')}>Remove</button>
            {typeof currentImage === 'object' && (
              <small style={{display: 'block', color: '#666', marginTop: '5px'}}>
                📁 {currentImage.fileName} (will upload on publish)
              </small>
            )}
          </div>
        ) : (
          <div className="upload-prompt">
            <p>📷 Upload image directly to S3</p>
            <input 
              type="file" 
              accept="image/*" 
              onChange={handleFileSelect}
              disabled={uploading}
            />
            {uploading && <p>⏳ Uploading to S3...</p>}
            <small>Max file size: 5MB | Supported: JPG, PNG, GIF</small>
          </div>
        )}
      </div>
      
      <div className="url-input">
        <label>Or enter image URL:</label>
        <input 
          type="url" 
          value={typeof currentImage === 'string' ? currentImage : ''} 
          onChange={(e) => {
            const url = e.target.value;
            // Allow S3 URLs and common image hosting
            if (url === '') {
              onImageUrl(url);
            } else if (url.startsWith('https://')) {
              try {
                const parsedUrl = new URL(url);
                // Allow S3 and common image hosting domains
                const allowedDomains = [
                  'emediaforum-images.s3.amazonaws.com',
                  's3.amazonaws.com',
                  'amazonaws.com',
                  'via.placeholder.com', 
                  'images.unsplash.com', 
                  'cdn.pixabay.com'
                ];
                if (allowedDomains.some(domain => parsedUrl.hostname.includes(domain))) {
                  onImageUrl(url);
                }
              } catch {
                // Invalid URL, ignore
              }
            }
          }}
          placeholder="https://example.com/image.jpg"
        />
      </div>
    </div>
  );
}

export default ImageUploader;